import Immutable from 'immutable'
import { createReducer } from 'redux-immutablejs'

import createDeferredReducer from '../utils/createDeferredReducer'
import { ADD, GET_ALL, UPDATE, REMOVE } from './actions'
import * as patientActions from '../patients/actions'
import { SUCCESS_SUFFIX, FAILURE_SUFFIX, REQUEST_SUFFIX } from '../utils/promiseMiddleware'

const {
  deferredCreate,
  deferredFailure,
  deferredSuccess,
} = createDeferredReducer('insuranceCompanies')

const initialState = Immutable.fromJS({
  all: Immutable.Map(),
  deferreds: {},
  isAllFetched: false,
})

function mergeInsuranceCompanyInState(state, action) {
  return state.mergeIn(['all'], Immutable.fromJS(action.payload.response.entities.insuranceCompany))
}

function mergeInsuranceCompaniesFromPatientAction(state, action) {
  const entities = action.payload.response.entities.insuranceCompany
  if (!entities) return state
  return state.mergeIn(['all'], Immutable.fromJS(entities))
}

export default createReducer(initialState, {
  [`${ADD}${SUCCESS_SUFFIX}`]: mergeInsuranceCompanyInState,
  [`${UPDATE}${SUCCESS_SUFFIX}`]: mergeInsuranceCompanyInState,
  [`${REMOVE}${SUCCESS_SUFFIX}`]: (state, action) => {
    const id = action.payload.request && action.payload.request._id
    if (!id) return state
    return state.deleteIn(['all', id])
  },
  [`${GET_ALL}${REQUEST_SUFFIX}`]: deferredCreate,
  [`${GET_ALL}${FAILURE_SUFFIX}`]: deferredFailure,
  [`${GET_ALL}${SUCCESS_SUFFIX}`]: (state, action) => {
    let newState = deferredSuccess(state, action)
    newState = newState.set('isAllFetched', true)
    newState = mergeInsuranceCompanyInState(newState, action)
    return newState
  },
  [`${patientActions.GET_ALL}${SUCCESS_SUFFIX}`]: mergeInsuranceCompaniesFromPatientAction,
  [`${patientActions.GET_BY_ID}${SUCCESS_SUFFIX}`]: mergeInsuranceCompaniesFromPatientAction,
  [`${patientActions.ADD}${SUCCESS_SUFFIX}`]: mergeInsuranceCompaniesFromPatientAction,
  [`${patientActions.UPDATE}${SUCCESS_SUFFIX}`]: mergeInsuranceCompaniesFromPatientAction,
})
